module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAALpJREFUWAljtO7/78n4l2HWfwYGGQY6AkYGhif/mRnSGG16/j+mt+Uwf4IcwTRQloMcAbKbCeaagaJHHTAaAqMhMBoCoyHAgqsItlBgYChzY2AQ48WlgjjxV58ZGLp2MTCceIBdPc4ooIblICtBHgCZhQvgdAAuDdQWx+kAULCBgo9SAIsCXOYwWvf8B1bLAwdwhgC9nDTqgNEQGA2B0RAYDQEmUAeRXsUuuj2QzimoizwAjgDZCeqeAwDKfCVbOa+CwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/asideIcon/hide.png
// module id = E7T/
// module chunks = 81